import { render, staticRenderFns } from "./MenuItem.vue?vue&type=template&id=28ec74fb"
import script from "./MenuItem.vue?vue&type=script&lang=ts"
export * from "./MenuItem.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports